import { type FC } from 'react';
import { cva } from 'class-variance-authority';
import cn from 'classnames';

import { type LotteryReward } from '@/common/types/lottery';
import { H1 } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import { prizeIcon, prizeOf, prizeValueText } from '../../prizes';

import { capImages } from './config';

import css from './styles.module.scss';

const rewardVariant = cva('', {
  variants: {
    variant: {
      1: css.first,
      2: css.second,
      3: css.third,
    },
  },
});

interface RewardForPlaceProps {
  className?: string;
  place: 1 | 2 | 3;
  reward?: LotteryReward;
}

const RewardForPlace: FC<RewardForPlaceProps> = ({
  place,
  reward,
  className,
}) => {
  const capImage = capImages[place];
  const prize = prizeOf(reward);
  const icon = prize && prizeIcon(prize.name);

  return (
    <div
      className={cn(
        css.rewardForPlace,
        rewardVariant({ variant: place }),
        className,
      )}
    >
      <span className={css.place}>{place}</span>
      <Picture {...capImage} />
      <H1
        weight="extrabold"
        className="absolute left-1/2 -translate-x-1/2 -bottom-[10px]"
      >
        {prize ? prizeValueText(prize.name, prize.value) : 0}
      </H1>
      {prize && icon && (
        <Picture
          className={cn(
            'absolute size-[32px] bottom-3',
            place === 1 ? '-right-1' : '-right-2',
          )}
          img={icon.png}
          webp={icon.webp}
          alt={prize.name}
        />
      )}
    </div>
  );
};

export { RewardForPlace };
